import "./OutAndBack.module.css";
import WildlingsWestHeader from "@/reusable_sections/Header";
import TestedInTheWild from "./sections/TestedInTheWild";
import OurEthicsAffiliateDisclosure from "./sections/OurEthicsAffiliateDisclosure";
import ExpeditionFooter from "@/reusable_sections/Footer";
export default function OutAndBackPage() {
  return <div>
      <WildlingsWestHeader />
      <TestedInTheWild />
      <OurEthicsAffiliateDisclosure />
      <ExpeditionFooter />
    </div>;
}